/* eslint-disable react/jsx-closing-tag-location */
import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';

function CalculateTimeSeconds({ dateToFormat }) {
    const timeNow = new Date().getTime();
    const newsDate = new Date(dateToFormat).getTime();
    const seconds = (timeNow - newsDate) / 1000;

    const anos = Math.floor(seconds / 60 / 60 / 24 / 30 / 12);

    if (anos > 0) {
        return <div className="qtdTime" suppressHydrationWarning>
            {anos}
            {' '}
            A
        </div>;
    }

    const meses = Math.floor(seconds / 60 / 60 / 24 / 30);

    if (meses > 0) {
        return <div className="qtdTime" suppressHydrationWarning>
            {meses}
            {' '}
            M
        </div>;
    }

    const semanas = Math.floor(seconds / 60 / 60 / 24 / 7);

    if (semanas > 0) {
        return <div className="qtdTime" suppressHydrationWarning>
            {semanas}
            {' '}
            S
        </div>;
    }

    const dias = Math.floor(seconds / 60 / 60 / 24);

    if (dias > 0) {
        return <div className="qtdTime" suppressHydrationWarning>
            {dias}
            {' '}
            D
        </div>;
    }

    const horas = Math.floor(seconds / 60 / 60);

    if (horas > 0) {
        return <div className="qtdTime" suppressHydrationWarning>
            {horas}
            {' '}
            H
            {' '}
        </div>;
    }

    return <div className="qtdTime" suppressHydrationWarning>1 min</div>;
}

CalculateTimeSeconds.propTypes = exact({
    dateToFormat: PropTypes.string,
})

export default CalculateTimeSeconds;
